export default IaphubMock = {
  init: () => { },
  setUserId: () => { },
  getProductsForSale: () => { },
  getActiveProducts: () => { },
  buy: () => { },
  restore: () => { },
};
